/*jslint white: true, nomen: true, unparam : true, es5: true */
/*global document, window, Cookies, jQuery */
(function( $ ) {
    "use strict";

    $(window).on('scroll', function() {
	if ($(window).scrollTop() > 1) { // Changement après 100px
            $('#header-menu').addClass('scrolled');
	} else {
            $('#header-menu').removeClass('scrolled');
	}
    });

    function initMobileCarousel() {
        if ($(window).width() <= 768) {
            $('.carrousel-mobile').each(function() {
                const $section = $(this);
                const $container = $section.find('.elementor-container');
                const $columns = $container.find('.elementor-column');
                
                // Si le carrousel n'est pas déjà initialisé
                if (!$container.find('.slides-wrapper').length) {
                    // Wrapper pour le slide
                    $columns.wrapAll('<div class="slides-wrapper"></div>');
                    
                    // Ajoute les boutons de navigation
                    const $nav = $('<div>', {
                        class: 'carousel-nav'
                    }).html(`
                        <button class="nav-button prev">&#10094;</button>
                        <button class="nav-button next">&#10095;</button>
                    `);
                    $container.append($nav);
                }
    
                const $wrapper = $container.find('.slides-wrapper');
                let currentSlide = 0;
    
                function updateSlides(animate = true) {
                    const slideWidth = $container.width();
                    const translateX = -currentSlide * slideWidth;
                    
                    if (animate) {
                        $wrapper.css({
                            'transition': 'transform 0.3s ease-in-out',
                            'transform': `translateX(${translateX}px)`
                        });
                    } else {
                        $wrapper.css({
                            'transition': 'none',
                            'transform': `translateX(${translateX}px)`
                        });
                    }
                }
    
                function goToSlide(index, animate = true) {
                    currentSlide = index;
                    updateSlides(animate);
                }
    
                function nextSlide() {
                    currentSlide = (currentSlide + 1) % $columns.length;
                    updateSlides();
                }
    
                function prevSlide() {
                    currentSlide = (currentSlide - 1 + $columns.length) % $columns.length;
                    updateSlides();
                }
    
                // Event listeners
                $container.find('.prev').on('click', prevSlide);
                $container.find('.next').on('click', nextSlide);
    
                // Support du swipe
                let touchStartX = 0;
                let touchEndX = 0;
                
                $container.on('touchstart', function(e) {
                    touchStartX = e.originalEvent.touches[0].screenX;
                    // Désactive la transition pendant le swipe
                    $wrapper.css('transition', 'none');
                });
    
                $container.on('touchmove', function(e) {
                    if (touchStartX) {
                        const currentX = e.originalEvent.touches[0].screenX;
                        const diff = touchStartX - currentX;
                        const slideWidth = $container.width();
                        const currentTranslate = -currentSlide * slideWidth;
                        
                        $wrapper.css('transform', `translateX(${currentTranslate - diff}px)`);
                    }
                });
    
                $container.on('touchend', function(e) {
                    touchEndX = e.originalEvent.changedTouches[0].screenX;
                    const difference = touchStartX - touchEndX;
                    
                    // Réactive la transition
                    $wrapper.css('transition', 'transform 0.3s ease-in-out');
                    
                    if (Math.abs(difference) > 50) { // seuil de 50px
                        if (difference > 0) {
                            nextSlide();
                        } else {
                            prevSlide();
                        }
                    } else {
                        // Retour à la position initiale si le swipe n'est pas assez long
                        updateSlides();
                    }
                });
    
                // Initial setup
                updateSlides(false);
    
                // Gérer le redimensionnement pendant l'animation
                let resizeTimeout;
                $(window).on('resize', function() {
                    clearTimeout(resizeTimeout);
                    resizeTimeout = setTimeout(function() {
                        updateSlides(false);
                    }, 100);
                });
            });
        }
    }
    
    // Appeler la fonction au chargement
    $(document).ready(function() {
        initMobileCarousel();
    });
    
    // Gérer le redimensionnement
    $(window).on('resize', function() {
        initMobileCarousel();
        if ($(window).width() > 768) {
            // Réinitialise tout si on passe en desktop
            $('.carrousel-mobile').each(function() {
                const $section = $(this);
                const $container = $section.find('.elementor-container');
                const $columns = $container.find('.elementor-column');
                
                // Restaure la structure originale
                if ($container.find('.slides-wrapper').length) {
                    $columns.unwrap('.slides-wrapper');
                }
                
                $columns.css({
                    'transform': '',
                    'transition': '',
                    'display': 'block'
                });
                
                $container.find('.carousel-nav').remove();
            });
        }
    });
}( jQuery ) );
